// src/utils/RetriggerConfirmationModal.jsx
import React from 'react';

const RetriggerConfirmationModal = ({
  show,
  onClose,
  onConfirm,
  processName,
  bodyContent
}) => {
  if (!show) return null;

  return (
    <div className="modal fade show d-block bg-dark bg-opacity-50">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <p className="mb-0 ev-fs-15 ev-bold-med">
              Confirm Retrigger {processName}
            </p>
            <button 
              type="button" 
              className="btn-close" 
              onClick={onClose}
            ></button>
          </div>
          <div className="modal-body ev-fs-12">
            <p>
              Are you sure you want to retrigger the <strong>{processName}</strong> process?
            </p>
            {bodyContent && (
              <div>
                {bodyContent}
              </div>
            )}
          </div>
          <div className="modal-footer">
            <button 
              type="button" 
              className="btn btn-secondary ev-btn-reg"
              onClick={onClose}
            >
              Cancel
            </button>
            <button 
              type="button" 
              className="btn btn-primary ev-btn-reg"
              onClick={onConfirm}
            >
              Confirm Retrigger
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RetriggerConfirmationModal;